import React from "react";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCoffee, faHome } from '@fortawesome/free-solid-svg-icons';
import { faArrowRight, faCheckCircle, faCircle, faCircleCheck, faDashboard, faMagnifyingGlass, faMap, faUser, faUserAlt, faUsers } from "../../../node_modules/@fortawesome/free-solid-svg-icons/index";
import { faList } from "../../../node_modules/@fortawesome/free-solid-svg-icons/index";
// import { menuCodeData } from "../Home/Access";
const CDPSideBar = () => { 

    return (

        <aside id="myDIV" className="sidebar">

            <ul className="sidebar-nav" id="sidebar-nav">

               <li className="nav-item">
                    <NavLink className="nav-link collapsed" to="/inspection/dashboard">
                        <i><FontAwesomeIcon icon={faDashboard} /></i>
                        <span> Dashboard</span>
                    </NavLink>
                </li>             

                <li className="nav-item">
                    <NavLink className="nav-link collapsed" to="/inspection/details">
                        <i><FontAwesomeIcon icon={faUser} /></i>
                        <span>Inspection Details</span>
                    </NavLink>
                </li>

                <li className="nav-item">
                    <NavLink className="nav-link collapsed" to="/inspection/map">
                        <i><FontAwesomeIcon icon={faUser} /></i>
                        <span>Inspection Map</span>
                    </NavLink>
                </li>

                <li className="nav-item" style={{display: "none"}}>
                    <NavLink className="nav-link collapsed" to="/inspection/map">
                        <i><FontAwesomeIcon icon={faUserAlt} /></i>
                        <span>Inspection Map</span>
                    </NavLink>
                </li>
                <li className="nav-item">
                    <NavLink className="nav-link collapsed" to="/home/access">
                        <i><FontAwesomeIcon icon={faDashboard} /></i>
                        <span> All Schemes</span>
                    </NavLink>
                </li>

            </ul>

        </aside>
    )

}

export default CDPSideBar;